    
/* eslint-disable react/jsx-no-bind */
import React, { Component } from 'react'
import { Col, Row, FormGroup } from "react-bootstrap"
import {  Field, reduxForm, propTypes,formValueSelector,getFormSyncErrors,change   } from 'redux-form'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import { saveSeasonParticipant , resetParticipantSettings } from "../../../redux/actions/action_seasonsettings"
import { lblattrs9 } from '../../../utils/style'
import { onlypositivenumbers } from '../../../utils/helperfunctions/onlypositivenumbers'
import { defaultformstate } from '../../../utils/statedefaultvalues/formstate'
import SeasonHeader from './SeasonHeader'
import ErrorList from './ErrorList'
import InfoSaved from './InfoSaved'

const formName       = 'seasonparticipants'
const participantTab = 4

class Participant extends Component {
    static propTypes = {
        ...propTypes
    }
    constructor(props,context) {
        super(props,context)
        this.handleSaveParticipant = this.handleSaveParticipant.bind(this) 
        this.handleValueChange  = this.handleValueChange.bind(this)
    }
    componentDidUpdate() {

        const { initialize,datasaved,settingsSaved,resetform,resetParticipantSettings,resetDone,participantreset,dispatch } = this.props
        if (datasaved) {
            initialize({}, true)
            settingsSaved(true,participantTab)
        }
        if(resetform == true){
            resetParticipantSettings()
        }
        if(participantreset == true){
            dispatch(change(formName,'participantreset',false))
            resetDone()
        }
    }
    handleSaveParticipant() {
        const { saveSeasonParticipant, participants, settingsseason, dispatch } = this.props
        const season = participants[settingsseason]
       
        const seasonparticipant = {
            minWomenTeams:season.minWomenTeams,
            minMenTeams:season.minMenTeams,
            maxNumberNcaaTeams:season.maxNumberNcaaTeams,
            maxNumberNonNcaaTeams:season.maxNumberNonNcaaTeams,
            maxNumberBowlersPerSeason:season.maxNumberBowlersPerSeason,
            maxNumberBowlersPerEvent:season.maxNumberBowlersPerEvent,
            maxNumberTeamAthletesPerEvent:season.maxNumberTeamAthletesPerEvent,
            minNumberTeamAthletesPerEvent:season.minNumberTeamAthletesPerEvent,
            rosterMaxFirstSemester:season.rosterMaxFirstSemester,
            rosterMaxSecondSemester: season.rosterMaxSecondSemester,
            seasonId:settingsseason
        }
        dispatch(change(formName, 'savingdata',true))
        saveSeasonParticipant(settingsseason,seasonparticipant)
    }
    handleValueChange() {
        const { dispatch, settingsSaved } = this.props
        dispatch(change(formName,'datasaved',false))
        settingsSaved(false,participantTab)
    }
    render() {
        const { participants,settingsseason,savingdata,datasaved,seasonyears, syncErrors } = this.props
        const season    = `participants[${settingsseason}]`
        const errors    =  Object.values(syncErrors)
        let isSeasonSet = true
        
        if(participants){
            isSeasonSet = participants[settingsseason].isSeasonSet
        }
      
        return (
            <Row className="center-block center-text">
                <form className="form-horizontal" sm={5}  style={{ padding:'0',margin:'0' }} >
                    <Col sm={5}>
                        <FormGroup>
                            <SeasonHeader seasonyears={seasonyears} />   
                        </FormGroup>
                        { (errors.length > 0) && <ErrorList errors={errors}/> }
                        <FormGroup>
                            <label className={lblattrs9}>Minimum # of Women teams</label>
														<Field
																type='number'
																name={`${season}.minWomenTeams`}
																component='input'
																className="form-control no-spinners"
																style={{ maxWidth: '70px' }}
																max = {7}  
																onChange={this.handleValueChange}  
																parse={onlypositivenumbers}                                     
														/>
														</FormGroup>
														<FormGroup>
																<label className={lblattrs9}>Minimum # of Men teams</label>
																<Field
																		type='number'
																		name={`${season}.minMenTeams`}
																		component='input'
																		className="form-control no-spinners"
																		style={{ maxWidth: '70px' }}
																		max = {10}    
																		onChange={this.handleValueChange} 
																		parse={onlypositivenumbers}                                     
																/>
														</FormGroup>
														<FormGroup>
																<label className={lblattrs9}>Maximum # of players in NCAA events</label>
																<Field
																		type='number'
																		name={`${season}.maxNumberNcaaTeams`}
																		component='input'
																		className="form-control no-spinners"
																		style={{ maxWidth: '70px' }}
																		max = {20}  
																		onChange={this.handleValueChange}  
																		parse={onlypositivenumbers}                                      
																/>
														</FormGroup>
														<FormGroup>
																<label className={lblattrs9}>Maximum # of players in non-NCAA events</label>
																<Field
																		type='number'
																		name={`${season}.maxNumberNonNcaaTeams`}
																		component='input'
																		className="form-control no-spinners"
																		style={{ maxWidth: '70px' }}
																		max = {4}   
																		onChange={this.handleValueChange}  
																		parse={onlypositivenumbers}                                    
																/>
														</FormGroup>
														<FormGroup>
																<label className={lblattrs9}>Roster Max (1st Semester)</label>
																<Field
																		type='number'
																		name={`${season}.rosterMaxFirstSemester`}
																		component='input'
																		className="form-control no-spinners"
																		style={{ maxWidth: '70px' }}
																		max = {4}  
																		onChange={this.handleValueChange}   
																		parse={onlypositivenumbers}                                     
																/>
														</FormGroup>
														<FormGroup>
																<label className={lblattrs9}>Roster Max (2nd Semester)</label>
																<Field
																		type='number'
																		name={`${season}.rosterMaxSecondSemester`}
																		component='input'
																		className="form-control no-spinners"
																		style={{ maxWidth: '70px' }}
																		max = {4}  
																		onChange={this.handleValueChange}  
																		parse={onlypositivenumbers}                                      
																/>
														</FormGroup>
														<FormGroup>
																<label className={lblattrs9}>Min # of team athletes per event</label>
																<Field
																		type='number'
																		name={`${season}.minNumberTeamAthletesPerEvent`}
																		component='input'
																		className="form-control no-spinners"
																		style={{ maxWidth: '70px' }}
																		max = {4}  
																		onChange={this.handleValueChange}   
																		parse={onlypositivenumbers}                                     
																/>
														</FormGroup>
														<FormGroup>
																<label className={lblattrs9}>Max # of team athletes per event</label>
																<Field
																		type='number'
																		name={`${season}.maxNumberTeamAthletesPerEvent`}
																		component='input'
																		className="form-control no-spinners"
																		style={{ maxWidth: '70px' }}
																		max = {4}  
																		onChange={this.handleValueChange}   
																		parse={onlypositivenumbers}                                     
																/>
														</FormGroup>
														<FormGroup>
															<Col lgOffset={ 2 } lg={ 10 }>
																	<button type="button"   className="btn btn-primary"  style={{ marginLeft:'20px' }} onClick={this.handleSaveParticipant} disabled={(datasaved == undefined) || (datasaved == true)  || errors.length > 0 || !isSeasonSet}>
																			<i className={savingdata == true? 'fa fa-spinner fa-spin':"fa fa-cogs"} aria-hidden="true" /> &nbsp;&nbsp;Save Settings
																	</button>
																	{
																					datasaved && (<InfoSaved section='Season participants' />)
																	}
															</Col>
														</FormGroup>
													</Col>
												</form>
        </Row>)
    }
}
function validate(values) {
    const { settingsseason,participants } = values
    const errors = {}
 
    if(participants && settingsseason) {
        const season = participants[settingsseason]
        const { maxNumberBowlersPerEvent, maxNumberBowlersPerSeason , maxNumberNonNcaaTeams, maxNumberNcaaTeams,minMenTeams,minWomenTeams,isSeasonSet } = season 
        let errorCounter = 0    
        
        if( isSeasonSet )   {

            // check all values are provided
            if (!maxNumberBowlersPerEvent || maxNumberBowlersPerEvent <= 0) {
                errors[errorCounter++] = "Maximun number of bowlers per event must be a positive number"
            }
            if (!maxNumberBowlersPerSeason  || maxNumberBowlersPerSeason <= 0) {
                errors[errorCounter++] = "Maximun number of bowlers per season must be a positive number"
            }
            if (!maxNumberNonNcaaTeams  || maxNumberNonNcaaTeams <= 0) {
                errors[errorCounter++] = "Maximun number of non NCAA teams must be a positive number"
            }
            if (!maxNumberNcaaTeams  || maxNumberNcaaTeams <= 0) {
                errors[errorCounter++] = "Maximun number of NCAA teams must be a positive number"
            }
            if (!minMenTeams  || minMenTeams <= 0) {
                errors[errorCounter++] = "Minimum number of men teams must be a positive number"
            }
            if (!minWomenTeams  || minWomenTeams <= 0) {
                errors[errorCounter++] = "Minimum number of women teams must be a positive number"
            }
        }
        else {
            
            if( isSeasonSet != undefined  ){
                errors[errorCounter++]  = "Initiate the season by clicking 'Setup season' in the Season Dates tab"
            }
        }  
    }

    return errors
} 
Participant.propTypes = {
    dispatch:PropTypes.func,
    initialize:PropTypes.func,
    syncErrors:PropTypes.object,
    settingsseason:PropTypes.number,
    savingdata:PropTypes.bool,
    datasaved:PropTypes.bool,
    seasonyears:PropTypes.string,
    participants:PropTypes.object,
    saveSeasonParticipant: PropTypes.func,
    settingsSaved: PropTypes.func,
    resetParticipantSettings: PropTypes.func,
    resetDone:PropTypes.func,
    resetform:PropTypes.bool,
    participantreset:PropTypes.bool
 }
function mapStateToProps(state,ownProps){
    const formName =  ownProps.form
    const selector = formValueSelector(formName)
    const settingsseason     = selector(state,'settingsseason')
    const participants       = selector(state,'participants')
    const savingdata         = selector(state,'savingdata')
    const datasaved          = selector(state,'datasaved')
    const participantreset   = selector(state,'participantreset')
    const syncErrors = getFormSyncErrors(formName)(state)
    return {     
        settingsseason,
        participants,
        savingdata,
        datasaved,
        participantreset,
        syncErrors  
    }
}
function mapDispatchToProps(dispatch){
    return bindActionCreators({
        saveSeasonParticipant,
        resetParticipantSettings
    },dispatch)
}
export default reduxForm({
  validate,
  form:formName,
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: false,
  initialValues:defaultformstate,
  enableReinitialize: true
})(connect(mapStateToProps,mapDispatchToProps)(Participant))




// WEBPACK FOOTER //
// ./src/containers/season/Components/Participant.js